import React from 'react';
import cx from 'classnames';
import css from './Vulnerabilities.module.scss';
import { CaseDetails } from '../../../CaseDetailsPage.types';
import VulnerabilityForm from './VulnerabilityForm';
import { Button } from 'modules/af_cm_ui_kit';
import { FormProvider, useForm } from 'react-hook-form';
import useYupValidationResolver from 'form/yup/reactHookFormResolver';
import validationSchema from './validationSchema';
import { Form, FormVulnerbaility } from './Vulnerability';

interface Props {
  item: Form;
  categoryResources: CaseDetails['resources']['vulnerabilityCategories'];
  informationResources: CaseDetails['resources']['informationProvidedBy'];
  onCancel: () => void;
  onCreate: (vulnerability: FormVulnerbaility) => void;
}

const CreatedVulnerabilityListItem = ({ item, categoryResources, informationResources, onCancel, onCreate }: Props) => {
  const methods = useForm<Form>({
    mode: 'onBlur',
    resolver: useYupValidationResolver(validationSchema()),
    defaultValues: item,
  });

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit((data) => {
    onCreate(data as FormVulnerbaility);
  });

  return (
    <>
      <p className={css.title}>New vulnerability</p>

      <div className={css.content}>
        <FormProvider<Form> {...methods}>
          <form onSubmit={onSubmit}>
            <>
              <VulnerabilityForm categoryResources={categoryResources} informationResources={informationResources} />
              <div className={cx(css.stack, css.formActions)}>
                <Button mode="ghost" onClick={onCancel} type="button">
                  Cancel
                </Button>
                <Button mode="primary" type="submit">
                  Save
                </Button>
              </div>
            </>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default CreatedVulnerabilityListItem;
